import React from 'react';

const TextSection = ({
  heading,
  headingHref,
  body,
  className = ''
}) => {
  if (!heading && !body) {
    return null;
  }

  return (
    <div className={className}>
      {heading && (
        <h2 className="text-3xl font-semibold text-primary-900 sm:text-4xl">
          {headingHref ? (
            <a
              href={headingHref}
              target="_blank"
              rel="noreferrer"
              className="break-words underline decoration-2 underline-offset-4 hover:text-primary-700"
            >
              {heading}
            </a>
          ) : (
            heading
          )}
        </h2>
      )}

      {body && (
        <p className="mt-4 text-lg text-gray-700">
          {body}
        </p>
      )}
    </div>
  );
};

export default TextSection;